import content from "@/data/content";
export default {
  computed: {
    queryBuilder() {
      let query = {};
      for (let i = 1; i <= this.level; i++) {
        query["level" + i] = this.$route.query["level" + i];
      }
      return query;
    },
    content() {
      if (this.level >= 1) {
        let reduced = Array(this.level)
          .fill(0)
          .map((_, i) => i + 1)
          .reduce((prev, curr) => {
            let level = "level" + curr;
            let choice = this.$route.query[level];
            if (
              prev[level] !== undefined &&
              prev[level][choice] !== undefined
            ) {
              prev = prev[level][choice];
              return prev;
            } else {
              return false;
            }
          }, content);
        if (!reduced)
          this.$router
            .push({ path: "/", query: { error: true } })
            .catch(() => {});
        return reduced;
      }
      return content;
    },
    nextLevel() {
      return "level" + (this.level + 1);
    },
  },
};
